import { getInterface } from '@/utils/js/initVariable';
const prefixUrl = 'api/RegionDirectoryApi/'; // 名录
/**
 * 新增名录
 */
export const addRegionDirectory = (data)=>{
  return getInterface.post(`${prefixUrl}addRegionDirectory`, data);
}
/**
 * 名录List
 */
export const queryRegionDirectoryList = (data)=>{
  return getInterface.post(`${prefixUrl}queryRegionDirectoryList`, data);
}
// 删除名录
export const deleteRegionDirectory = (data)=>{
  return getInterface.postForm(`${prefixUrl}deleteRegionDirectory`, data);
}
// 持续跟踪名录
export const queryRegionDirectoryTaskResult = (data)=>{
  return getInterface.postForm(`${prefixUrl}queryRegionDirectoryTaskResult`, data);
}
// 名录轨迹查询
export const queryContinuousStatisticsRegionDirectoryTrack = (data)=>{
  return getInterface.post(`${prefixUrl}queryContinuousStatisticsRegionDirectoryTrack`, data);
}